import React, { useState } from 'react';
import './LoginPage.css';

function LoginPage({ onNavigate }) {
  const [showPw, setShowPw] = useState(false);
  const [formData, setFormData] = useState({
    genesisID: '',
    password: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch('https://orkxz4jpah.execute-api.us-east-1.amazonaws.com/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (result.success) {
        console.log('User logged in:', result.user);
        
        // Встановлюємо термін дії на 30 днів
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 30);

        const userWithExpiration = {
          ...result.user,
          expirationDate: expirationDate.toISOString()
          , sessionToken: result.sessionToken || null
        };

        // Зберігаємо з терміном дії
        localStorage.setItem('currentUser', JSON.stringify(userWithExpiration));
        
        onNavigate('profile');
      } else {
        alert(`Login failed: ${result.error}`);
      }
    } catch (error) {
      console.error('Network error:', error);
      alert(`Network error: ${error.message}`);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              name="genesisID"
              placeholder="Genesis ID"
              value={formData.genesisID}
              onChange={handleChange}
              required
              autoComplete="username"
            />
          </div>
          <div className="form-group">
            <input
              type={showPw ? 'text' : 'password'}
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              autoComplete="current-password"
            />
          </div>
          <button type="button" onClick={() => setShowPw(!showPw)}
            style={{ background: 'none', border: 'none', color: '#3498db', fontSize: '0.9rem', cursor: 'pointer', padding: 0, margin: '-10px 0 16px', display: 'block' }}>
            {showPw ? '🙈 Hide password' : '👁 Show password'}
          </button>
          <div className="form-actions">
            <button type="submit" className="btn-login">Login</button>
            <button type="button" className="btn-back" onClick={() => onNavigate('home')}>
              Back to Home
            </button>
                        <button type="button" onClick={() => onNavigate('reset-password')}
              style={{ background: 'none', border: 'none', color: '#3498db', cursor: 'pointer', fontSize: '0.95rem', marginTop: '6px' }}>
              Forgot password or Genesis ID?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;